import {Injector, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'subtask'
})
export class SubtaskPipe implements PipeTransform {

  constructor(private injector: Injector) {}

  transform(value: any, args?: any): any {

    const _translate = this.injector.get(TranslateService);

    if (value != null) {
      // Current State (Number)
      value = Number(value);
    }

    // state is negative - global
    if (value === -3) {
      return value + ` (${_translate.instant('stateWorkflow.WF2.MINUS_THREE')})`;
    }
    if (value === -2) {
      return value + ` (${_translate.instant('stateWorkflow.WF2.MINUS_TWO')})`;
    }
    if (value === -1) {
      return value + ` (${_translate.instant('stateWorkflow.WF2.MINUS_ONE')})`;
    }

    // Workflow Type
    switch (args) {

      case 'WF1': // 0 1 2
        // not started yet
        if (value == null) {
          return `- (${_translate.instant('stateWorkflow.WF1.NULL')})`;
        }
        if (value === 0) {
          return value + ` (${_translate.instant('stateWorkflow.WF1.ZERO')})`;
        }
        if (value === 1) {
          return value + ` (${_translate.instant('stateWorkflow.WF1.ONE')})`;
        }
        if (value === 2) {
          return value + ` (${_translate.instant('stateWorkflow.WF1.TWO')})`;
        }
        break;
      case 'WF1ST1': // 0 1 2 3
        if (value === 0) {
          return value + ` (${_translate.instant('stateWorkflow.WF1ST1.ZERO')})`;
        }
        if (value === 1) {
          return value + ` (${_translate.instant('stateWorkflow.WF1ST1.ONE')})`;
        }
        if (value === 2) {
          return value + ` (${_translate.instant('stateWorkflow.WF1ST1.TWO')})`;
        }
        if (value === 3) {
          return value + ` (${_translate.instant('stateWorkflow.WF1ST1.THREE')})`;
        }
        break;
      case 'WF2': // -3 -2 -1 0 1 2 3 4 5 6 7 8 9 10 11 12 13
        // not started yet
        if (value == null) {
          return `- (${_translate.instant('stateWorkflow.WF2.NULL')})`;
        }
        if (value === 0) {
          return value + ` (${_translate.instant('stateWorkflow.WF2.ZERO')})`;
        }
        if (value === 1) {
          return value + ` (${_translate.instant('stateWorkflow.WF2.ONE')})`;
        }
        if (value === 2) {
          return value + ` (${_translate.instant('stateWorkflow.WF2.TWO')})`;
        }
        if (value === 3) {
          return value + ` (${_translate.instant('stateWorkflow.WF2.THREE')})`;
        }
        if (value === 4) {
          return value + ` (${_translate.instant('stateWorkflow.WF2.FOUR')})`;
        }
        if (value === 5) {
          return value + ` (${_translate.instant('stateWorkflow.WF2.FIVE')})`;
        }
        if (value === 6) {
          return value + ` (${_translate.instant('stateWorkflow.WF2.SIX')})`;
        }
        if (value === 7) {
          return value + ` (${_translate.instant('stateWorkflow.WF2.SEVEN')})`;
        }
        if (value === 8) {
          return value + ` (${_translate.instant('stateWorkflow.WF2.EIGHT')})`;
        }
        if (value === 9) {
          return value + ` (${_translate.instant('stateWorkflow.WF2.NINE')})`;
        }
        if (value === 10) {
          return value + ` (${_translate.instant('stateWorkflow.WF2.TEN')})`;
        }
        if (value === 11) {
          return value + ` (${_translate.instant('stateWorkflow.WF2.ELEVEN')})`;
        }
        if (value === 12) {
          return value + ` (${_translate.instant('stateWorkflow.WF2.TWELVE')})`;
        }
        if (value === 13) {
          return value + ` (${_translate.instant('stateWorkflow.WF2.THIRTEEN')})`;
        }
        break;
      case 'WF2ST1': // 0 1 2 3
        if (value === 0) {
          return value + ` (${_translate.instant('stateWorkflow.WF2ST1.ZERO')})`;
        }
        if (value === 1) {
          return value + ` (${_translate.instant('stateWorkflow.WF2ST1.ONE')})`;
        }
        if (value === 2) {
          return value + ` (${_translate.instant('stateWorkflow.WF2ST1.TWO')})`;
        }
        if (value === 3) {
          return value + ` (${_translate.instant('stateWorkflow.WF2ST1.THREE')})`;
        }
        break;
      case 'WF2ST2': // 0 1 2 3 4 5
        if (value === 0) {
          return value + ` (${_translate.instant('stateWorkflow.WF2ST2.ZERO')})`;
        }
        if (value === 1) {
          return value + ` (${_translate.instant('stateWorkflow.WF2ST2.ONE')})`;
        }
        if (value === 2) {
          return value + ` (${_translate.instant('stateWorkflow.WF2ST2.TWO')})`;
        }
        if (value === 3) {
          return value + ` (${_translate.instant('stateWorkflow.WF2ST2.THREE')})`;
        }
        if (value === 4) {
          return value + ` (${_translate.instant('stateWorkflow.WF2ST2.FOUR')})`;
        }
        if (value === 5) {
          return value + ` (${_translate.instant('stateWorkflow.WF2ST2.FIVE')})`;
        }
        break;
      case 'WF2ST3': // 0 1 2
        if (value === 0) {
          return value + ` (${_translate.instant('stateWorkflow.WF2ST3.ZERO')})`;
        }
        if (value === 1) {
          return value + ` (${_translate.instant('stateWorkflow.WF2ST3.ONE')})`;
        }
        if (value === 2) {
          return value + ` (${_translate.instant('stateWorkflow.WF2ST3.TWO')})`;
        }
        break;
      case 'WF2ST4': // 0 1 2 3
        if (value === 0) {
          return value + ` (${_translate.instant('stateWorkflow.WF2ST4.ZERO')})`;
        }
        if (value === 1) {
          return value + ` (${_translate.instant('stateWorkflow.WF2ST4.ONE')})`;
        }
        if (value === 2) {
          return value + ` (${_translate.instant('stateWorkflow.WF2ST4.TWO')})`;
        }
        if (value === 3) {
          return value + ` (${_translate.instant('stateWorkflow.WF2ST4.THREE')})`;
        }
        break;
      case 'WF2ST6': // 0 1 2 3
        if (value === 0) {
          return value + ` (${_translate.instant('stateWorkflow.WF2ST6.ZERO')})`;
        }
        if (value === 1) {
          return value + ` (${_translate.instant('stateWorkflow.WF2ST6.ONE')})`;
        }
        if (value === 2) {
          return value + ` (${_translate.instant('stateWorkflow.WF2ST6.TWO')})`;
        }
        if (value === 3) {
          return value + ` (${_translate.instant('stateWorkflow.WF2ST6.THREE')})`;
        }
        break;
      case 'WF2ST7': // 0 1 2
        if (value === 0) {
          return value + ` (${_translate.instant('stateWorkflow.WF2ST7.ZERO')})`;
        }
        if (value === 1) {
          return value + ` (${_translate.instant('stateWorkflow.WF2ST7.ONE')})`;
        }
        if (value === 2) {
          return value + ` (${_translate.instant('stateWorkflow.WF2ST7.TWO')})`;
        }
        break;
      case 'WF3': // 0 1 2
        if (value === 0) {
          return value + ` (${_translate.instant('stateWorkflow.WF3.ZERO')})`;
        }
        if (value === 1) {
          return value + ` (${_translate.instant('stateWorkflow.WF3.ONE')})`;
        }
        if (value === 2) {
          return value + ` (${_translate.instant('stateWorkflow.WF3.TWO')})`;
        }
        break;
      default:
        return value + ` (${_translate.instant('stateWorkflow.GLOBAL.DEFAULT')})`;
    }

  }

}
